export const REGEX_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
export const REGEX_URL = /(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[A-Z]?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/[^()\s,]*)?/g;
export const REGEX_URL_BEGIN = /^(https?:\/\/(www.)?)/;
export const REGEX_FILE = /^[a-z0-9]+([-]{1}[a-z0-9]+)*\.(css|png|jpeg|js|gif|html)$/;
export const REGEX_TAG = /(@(?=.{6,}$))(?![_.])(?!.*[_.]{2})[a-zA-Z0-9_.-]+[^_.<\s]/g;
export const REGEX_TAG_ALONE = /(@(?=.{6,}$))(?![_.])(?!.*[_.]{2})[a-zA-Z0-9_.-]+[^<>_.,;]/g;
export const REGEX_SPAN = /<span class="Global__MentionUsernameColor">[\s\S]+?<\/span>/g;
export const REGEX_A = /<a[\s\S]+?<\/a>/g;
export const REGEX_IMG = /<img(?!.*(src=""))[^>]+?>/g;
export const REGEX_MEDIA = /\[MEDIA .+?\]/g;

// Style regex
export const REGEX_BOLD = /\*\*[\s\S]+?\*\*/g;
export const REGEX_ITALIC = /{{[\s\S]+?}}/g;
export const REGEX_UNDERLINE = /__[\s\S]+?__/g;
export const REGEX_BI = /\\\\[\s\S]+?\\\\/g;
export const REGEX_BU = /--[\s\S]+?--/g;
export const REGEX_IU = /\|\|[\s\S]+?\|\|/g;
export const REGEX_BIU = /\[\[[\s\S]+?\]\]/g;

// Line break regex
export const REGEX_BR = /<br\s*\/?>/g;

export const REGEX_NEWLINE = /\n\r?/g;
export const REGEX_SPACE = /^\s+/g;
